// DashboardWorkflowPanel.jsx
export default function DashboardWorkflowPanel({ actions }) {
    if (!actions || actions.length === 0) {
        return null;
    }

    return (
        <div className="flex gap-3 flex-wrap">
            {actions.map(action => (
                <button
                    className="
    px-4 py-2
    rounded-md
    bg-slate-900/80
    border border-slate-800
    text-sm text-gray-200
    hover:border-accent-action/60
    hover:text-white
    transition
  "
                >
                    View My Land
                </button>
            ))}
        </div>
    );
}